import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Popup, Icon, Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class DeleteIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {'isOpen': false};
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
  }

  handleOpen() {
    this.setState({'isOpen': true});
  }

  handleClose() {
    this.setState({'isOpen': false});
  }

  handleDeleteClick() {
    const {index} = this.props;

    this.props.removeElementFromProviderManualOrder(index);
    this.setState({'isOpen': false});
  }

  render() {
    return (
      <Popup wide inverted
        on='click'
        open={this.state.isOpen}
        onOpen={this.handleOpen}
        onClose={this.handleClose}
        trigger={<Icon link color='red' size='large' name='delete' />}
      >
        <Grid>
          <Grid.Row>
            <Grid.Column textAlign='center'>
              <div>¿Desea eliminar la línea del pedido?</div>
              <Button secondary
                size='mini'
                onClick={this.handleClose}
              >CANCELAR</Button>
              <Button primary
                size='mini'
                onClick={this.handleDeleteClick}
              >ELIMINAR</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Popup>
    );
  }
}

const {removeElementFromProviderManualOrder} = Actions;

export default connect(null, {
  removeElementFromProviderManualOrder,
})(DeleteIcon);
